// packages
import React from 'react';

import { DynamicObject } from 'src/utils/commonTypes';

import { useAppStore } from 'src/hooks/useAppStore';
import { mixpanelObject } from '../../utils/analytics/mixpanel/mixpanel';
import {
  MIXPANEL_AD_CAMPAIGN_ID,
  MIXPANEL_AD_CREATIVE_ID,
  MIXPANEL_AD_ID,
  MIXPANEL_AD_ISEMPTY,
  MIXPANEL_AD_LOCATION,
  MIXPANEL_AD_SIZE,
  MIXPANEL_VERTICAL_INDEX
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import { adBannerImpression } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import * as customStyled from './styles';

// css

type MyState = {
  adUnitPath: string | undefined;
  dimension: Array<Array<number> | string> | undefined;
  id: string | undefined;
  type: string | undefined;
  adTarget: Array<DynamicObject> | undefined;
  googleTagObj: DynamicObject | undefined;
};
type MyProps = {
  adUnit?: string | undefined;
  dimension?: Array<Array<number> | string> | undefined;
  id?: string | undefined;
  type?: string | undefined;
  adTarget?: Array<DynamicObject> | undefined;
  position?: string | number;
  pageType?: string;
  parentCompStyle?: string;
};
export default class AdComponent extends React.Component<MyProps, MyState> {
  timerFunc?: any;
  adRenderedArr?: Array<[]>;
  cssStyles?: any;

  constructor(props: any) {
    super(props);
    this.state = {
      adUnitPath: this.props.adUnit || undefined,
      dimension: this.props.dimension || undefined,
      id: this.props.id || undefined,
      type: this.props.type || undefined,
      adTarget: this.props.adTarget || undefined,
      googleTagObj: typeof window !== 'undefined' ? window.googletag : undefined
    };
    this.timerFunc = undefined;
    this.adRenderedArr = [];
    this.cssStyles = [];
  }

  // eslint-disable-next-line cyclomatic-complexity/zee-codeBlockComplexity
  componentDidMount() {
    if (typeof window?.googletag !== 'undefined') {
      this.getGoogleTag();
    }
    this.setState({
      googleTagObj: window.googletag
    });
    this.cssStyles?.push(customStyled.adContainer);
    const { parentCompStyle = '' } = this.props;
    const pageCss = `
      ${
        parentCompStyle === 'scoreBoardAdImg'
          ? customStyled.scoreBoardAdImg
          : ''
      }
      ${
        parentCompStyle === 'matchScheduleAdImg'
          ? customStyled.matchScheduleAdImg
          : ''
      }
      ${parentCompStyle === 'teamVideosAds' ? customStyled.teamVideosAds : ''}
      ${parentCompStyle === 'teamSquadAds' ? customStyled.teamSquadAds : ''}
      ${parentCompStyle === 'sportsVodAds' ? customStyled.sportsVodAds : ''}
    `;
    this.cssStyles?.push(pageCss);
  }

  componentWillUnmount() {
    if (
      this.state.googleTagObj &&
      this.state.googleTagObj.destroySlots &&
      typeof this.state.googleTagObj.destroySlots === 'function'
    ) {
      this.state.googleTagObj.destroySlots();
    }
    clearTimeout(this.timerFunc);
  }

  slotRenderedEnded = () => {
    window.googletag
      .pubads()
      .addEventListener('slotRenderEnded', (event: any) => {
        const adUnitPath = event.slot.getAdUnitPath(event);
        if (
          adUnitPath === this.state.adUnitPath &&
          this.adRenderedArr?.indexOf(adUnitPath) === -1
        ) {
          this.adRenderedArr.push(adUnitPath);
          mixpanelObject[MIXPANEL_VERTICAL_INDEX] = this.props.position;
          mixpanelObject[MIXPANEL_AD_ID] = event.advertiserId || 'N/A';
          mixpanelObject[MIXPANEL_AD_CAMPAIGN_ID] = event.campaignId || 'N/A';
          mixpanelObject[MIXPANEL_AD_CREATIVE_ID] = event.creativeId || 'N/A';
          mixpanelObject[MIXPANEL_AD_SIZE] = event.size || 'N/A';
          mixpanelObject[MIXPANEL_AD_LOCATION] = adUnitPath;
          mixpanelObject[MIXPANEL_AD_ISEMPTY] = event.isEmpty;
          adBannerImpression();
        }
      });
  };

  getGoogleTag = () => {
    if (window.googletag) {
      this.setState(
        {
          googleTagObj: window.googletag
        },
        () => {
          this.getAd();
          clearTimeout(this.timerFunc);
        }
      );
    } else {
      this.timerFunc = setTimeout(this.getGoogleTag, 300);
    }
  };

  getAd = () => {
    const { adUnitPath, id, dimension, type, adTarget, googleTagObj } =
      this.state;
    if (googleTagObj && googleTagObj.cmd) {
      googleTagObj.cmd.push(() => {
        const slot: DynamicObject = {};
        const uniqueSlotVariable = `${this.props.pageType}${this.props.position}${adUnitPath}`;
        slot[uniqueSlotVariable] = googleTagObj.defineSlot(
          adUnitPath,
          dimension,
          id
        );

        if (slot[uniqueSlotVariable]) {
          if (adTarget && adTarget.length) {
            adTarget.map((item) => {
              return slot[uniqueSlotVariable].setTargeting(
                item.key,
                item.value
              );
            });
          } else if (adTarget && Object.keys(adTarget).length) {
            Object.entries(adTarget).forEach(([key, value]) => {
              return slot[uniqueSlotVariable].setTargeting(key, value);
            });
          }
        }
        googleTagObj.pubads().addEventListener('slotOnload', () => {
          useAppStore().setCompanionAdState({ companionAdLoaded: true });
          if (
            type === ',' &&
            document.getElementsByClassName('companionAdATF').length
          ) {
            document
              .getElementsByClassName('companionAdATF')[0]
              .classList.add('companionAdBanner');
          }
        });

        if (type === 'companionAd') {
          slot[uniqueSlotVariable]
            .addService(googleTagObj.companionAds())
            .addService(googleTagObj.pubads());
          googleTagObj.companionAds().setRefreshUnfilledSlots(true);
          googleTagObj.pubads().enableVideoAds();
        } else {
          if (slot[uniqueSlotVariable].setCollapseEmptyDiv === 'function') {
            slot[uniqueSlotVariable]
              .setCollapseEmptyDiv(true, true)
              .addService(googleTagObj.pubads());
            // googleTagObj.pubads().refresh();
          }
          googleTagObj.pubads().enableSingleRequest();
        }
        // tercept integration
        // if (window.tercept && window.tercept.setTargeting) {
        //   window.tercept.setTargeting(slot[ uniqueSlotVariable ]);
        // } else {
        slot[uniqueSlotVariable].setTargeting('tcpt', ['TCPT_NL']);
        // }
        googleTagObj.enableServices();
        googleTagObj.display(id);
        this.slotRenderedEnded();
      });
    }
  };

  render() {
    const { id } = this.state;
    this.cssStyles?.push(customStyled.adContainer);
    const { parentCompStyle = '' } = this.props;
    const pageCss = `
      ${
        parentCompStyle === 'scoreBoardAdImg'
          ? customStyled.scoreBoardAdImg
          : ''
      }
      ${
        parentCompStyle === 'matchScheduleAdImg'
          ? customStyled.matchScheduleAdImg
          : ''
      }
      ${parentCompStyle === 'teamVideosAds' ? customStyled.teamVideosAds : ''}
      ${parentCompStyle === 'teamSquadAds' ? customStyled.teamSquadAds : ''}
      ${parentCompStyle === 'sportsVodAds' ? customStyled.sportsVodAds : ''}
    `;
    this.cssStyles?.push(pageCss);
    return (
      <React.Fragment>
        <div
          data-testid="ad-container"
          className="adContainer"
          css={this.cssStyles}>
          <div id={id} className="adImage" />
        </div>
      </React.Fragment>
    );
  }
}
